import { render } from "./Gift.vue?vue&type=template&id=588e6584"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Gift.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "588e6584"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('588e6584', __exports__)) {
    api.reload('588e6584', __exports__)
  }
  
  module.hot.accept("./Gift.vue?vue&type=template&id=588e6584", () => {
    api.rerender('588e6584', render)
  })

}


export default __exports__